import React, { FunctionComponent } from 'react';

import { Stack, Typography } from '@mui/material';
import { WINDOW_H, WINDOW_V } from '../../constant/constants';

interface Props {
  image1: any;
  image2: any;
  title: string;
  text: string;
  widthTitle: string;
  widthText: string;
  imageSize: string;
  windowState: number;
}

export const LendingDivtemTextWithImage: FunctionComponent<Props> = ({
  image1,
  image2,
  title,
  text,
  widthTitle,
  widthText,
  imageSize,
  windowState,
}) => (
  <Stack
    width="100%"
    paddingLeft={windowState === WINDOW_H ? '300px' : undefined}
    alignItems={windowState === WINDOW_H ? 'flex-end' : undefined}
  >
    {windowState === WINDOW_V && (
      <Stack
        width="100%"
        direction="row"
        paddingTop="40px"
        paddingBottom="40px"
        sx={{
          background: `url(${image2}), linear-gradient(90deg, rgba(229, 234, 237, 0) 40%, #E5EAED 70%)`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'right -50px  top',
          backgroundSize: imageSize,
        }}
        spacing={1}
      >
        <img
          alt=""
          width="32px"
          height="32px"
          style={{
            paddingLeft: '20px',
          }}
          src={image1}
        />
        <Stack paddingLeft="20px" spacing={1}>
          <Typography
            width={widthTitle}
            fontWeight={700}
            fontFamily="Comfortaa"
            fontSize="16px"
            letterSpacing="0.3px"
            textAlign="left"
            color="#000000"
            component="text"
          >
            {title}
          </Typography>
          <Typography
            width={widthText}
            fontWeight={400}
            fontFamily="Roboto"
            lineHeight="20px"
            fontSize="12px"
            letterSpacing="0.3px"
            textAlign="left"
            color="#000000"
            component="text"
          >
            {text}
          </Typography>
        </Stack>
      </Stack>
    )}
    {windowState === WINDOW_H && (
      <Stack
        width="100%"
        height="259px"
        direction="row"
        sx={{
          background: `url(${image2}), #E5EAED`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'left top',
          backgroundSize: imageSize,
          borderRadius: '40px 0 0 40px',
        }}
        spacing={1}
      >
        <img
          alt=""
          width="32px"
          height="32px"
          style={{
            paddingLeft: '345px',
            paddingTop: '61px',
          }}
          src={image1}
        />
        <Stack paddingLeft="20px" paddingTop="61px" spacing={1}>
          <Typography
            width={widthTitle}
            fontWeight={700}
            fontFamily="Comfortaa"
            fontSize="20px"
            letterSpacing="0.32px"
            textAlign="left"
            color="#000000"
            component="text"
          >
            {title}
          </Typography>
          <Typography
            width={widthText}
            fontWeight={400}
            fontFamily="Roboto"
            lineHeight="24px"
            fontSize="14px"
            letterSpacing="0.3px"
            textAlign="left"
            color="#000000"
            component="text"
          >
            {text}
          </Typography>
        </Stack>
      </Stack>
    )}
  </Stack>
);
